import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmblaOptionsType } from 'embla-carousel';
import { useMediaQuery } from 'react-responsive';
import { Headline } from '@oneaudi/unified-web-components';
import EmblaCarousel from '../EmblaCarousel';
import { TitleWrapper } from './FeaturedOffersList.styles';
import { PromotionType } from '../../types/offers';
import { device } from '../../styles/devices';

const OPTIONS: EmblaOptionsType = { loop: true };
const DESKTOP_OPTIONS: EmblaOptionsType = { loop: true, watchDrag: false };

const FeaturedOffersList: React.FC<{
  featuredOffers: PromotionType[];
}> = ({ featuredOffers }) => {
  const { t } = useTranslation();
  const isLaptop = useMediaQuery({ query: device.laptopMd });

  if (!featuredOffers.length) return null;

  return (
    <>
      <TitleWrapper>
        <Headline
          tag="h2"
          data-testid="header-copy"
          variant={{
            order: '2',
            type: 'headline',
            weight: 'normal',
          }}
        >
          {t('promo.offers.featuredOffersTitle')}
        </Headline>
      </TitleWrapper>
      <EmblaCarousel slides={featuredOffers} options={isLaptop ? DESKTOP_OPTIONS : OPTIONS} />
    </>
  );
};

export default FeaturedOffersList;
